<template>
  <v-container
    fluid
    grid-list-md
    v-if="
      selectedPlan !== null &&
        selectedPlan !== undefined &&
        planOptions !== null &&
        planOptions !== undefined
    "
  >
    <v-layout row wrap>
      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="assistant"
        :value="$t('views.billing.calculation_wizard')"
        v-if="role.indexOf('Broker Plan Manager') > -1"
      >
        <template slot="actions">
          <div class="d-flex justify-center">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'billingWizard',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.billing.run") }}
            </v-btn>
            <!-- <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'reviseWizard',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("globals.revise") }}
            </v-btn> -->
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
        v-if="
          planOptions.HasBillingImport &&
            (role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Broker Plan Admin') > -1)
        "
        :color="$vuetify.theme.themes.light.secondary"
        icon="mediation"
        :value="$t('views.contributions.employer_submissions')"
      >
        <template slot="actions">
          <div class="d-flex justify-center">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'contributionsWizard',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("globals.import") }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'contributionsView',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("globals.view") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
        v-if="
          planOptions.HasBilling &&
            (role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Broker Plan Admin') > -1 ||
              role.indexOf('Employer Plan Admin') > -1 ||
              role.indexOf('Employer Members Viewer') > -1 ||
              role.indexOf('Employer Billing Viewer') > -1)
        "
        :color="$vuetify.theme.themes.light.secondary"
        icon="card_membership"
        :value="$t('views.billing.billing_history')"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'billingArchive',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.billing.archive") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>

      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="local_parking"
        :value="$t('views.billing.premiums_history')"
        v-if="
          planOptions.HasPremiums &&
            (role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Broker Plan Admin') > -1 ||
              role.indexOf('Employer Premiums Viewer') > -1)
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'premiumsStatusTable',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.billing.records") }}
            </v-btn>

            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'premiumsArchive',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.billing.archive") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>

      <material-stats-card
        v-if="
          planOptions.HasRemittances &&
            (role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Broker Plan Admin') > -1)
        "
        :color="$vuetify.theme.themes.light.secondary"
        icon="account_balance"
        :value="$t('views.billing.remittances_history')"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'remittancesHistory',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.billing.records") }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'remittancesArchive',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.billing.archive") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>

      <material-stats-card
        v-if="
          planOptions.HasCommissions &&
            (role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Broker Plan Admin') > -1)
        "
        :color="$vuetify.theme.themes.light.secondary"
        icon="account_balance_wallet"
        :value="$t('views.billing.commissions_history')"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'commissionsTable',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.billing.records") }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'commissionsArchive',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.billing.archive") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>

    </v-layout>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";
export default {
  data() {
    return {};
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions", "planIdentity"]),
  },
  methods: {},
};
</script>

<style>
.with-margin {
  margin: 10px !important;
}
</style>
